var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"yj-aside",style:({ width: _vm.width })},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/aside/src/aside.vue